import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnChanges
} from '@angular/core';
import { AgmMap } from '@agm/core';
import { Package } from 'src/app/shared/models/package.model';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { PackagesService } from '../../packages.service';
import { SharedService } from 'src/app/shared/shared.service';
declare var $;
@Component({
  selector: 'app-view-package',
  templateUrl: './view-package.component.html',
  styleUrls: ['./view-package.component.css']
})
export class ViewPackageComponent
  implements OnInit, OnChanges, AfterViewInit {
  @Input() packageRow;
  @ViewChild('map', { static: false }) map: AgmMap;
  @ViewChild('modal', { static: false }) modal: ElementRef;
  @ViewChild('closeAddExpenseModal', { static: false })
  closeAddExpenseModal: ElementRef;
  countryRelatedCities = [];
  countriesWithCities = [];
  country: string;
  city: string;
  locationChange = false;
  private maplatitude = 29.0104002;
  private maplongitude = 31.7408658;
  mapType = 'roadmap';
  zoom = 7;
  markerDraggable = false;
  animation = 'DROP';
  package: Package;
  weekdays = [];
  startDay: string;
  rowPkg: any;
  constructor(private packageApi: PackagesService, private sharedApi: SharedService, private router: Router) {}

  ngOnInit() {
    moment.weekdays().forEach((element, index) => {
      const ind = Number(index) + 1;
      this.weekdays.push({ id: ind, name: element });
    });
    this.sharedApi.getAllCountries().subscribe((res: any) => {
      this.countriesWithCities = res.data.countries;
    });
    // if(this.map)
    // $(this.modal.nativeElement).on('shown.bs.modal', () => this.map.triggerResize());
  }
  ngAfterViewInit() {
    if (this.map) {
      $(this.modal.nativeElement).on('shown.bs.modal', () =>
        this.map.triggerResize()
      );
    }
  }
  ngOnChanges() {
    this.package = {};

    this.packageApi
      .getSinglePackageById(this.packageRow.id)
      .subscribe(Response => {
        console.log(Response.data, 'data');
        this.package = Response.data.experience;
        const findValue = this.weekdays.find(
          x => x.id === this.package.startIndex
        );
        // this.startDay = findValue.name;
        // this.sharedApi.getAllCountries().subscribe((res: any) => {
        //   this.countriesWithCities = res.data.countries;
        // });
        // if (this.countriesWithCities) {
        // const country = this.getCountryCities(
        //   Response.data.package.City[`countryId`]
        // );
        // }
        // if (country) {
        //   this.country = country[`name`];
        // }
        // this.city = Response.data.package.City.name;
      });
  }

  // getCountryCities(countryId): string {
  //   let cities;
  //   this.sharedApi.getAllCities(countryId).subscribe((Response) => {
  //       cities = Response.data.cities;
  //     });
  //   return cities;
  // }
  viewPkgSchedule() {
    this.closeAddExpenseModal.nativeElement.click();
    this.router.navigateByUrl('/packages/schedule/' + this.package.id);
  }
  cancel() {}
}
